'use client';
import { useState, useEffect, useRef } from 'react';
import { AxiosInstance } from '../utils';
function getDetails(conetntArray: any) {
    return (
        conetntArray.map((key: string) => {
            if (key.indexOf("href") >= 0 || key.indexOf("<span") >= 0 || key.indexOf("<h1>") >= 0 || key.indexOf("<h2>") >= 0 || key.indexOf("<h3>") >= 0 || key.indexOf("<h4>") >= 0) {
                return <li><i className="fa fa-check-circle-o"></i><span dangerouslySetInnerHTML={{ __html: key }}></span></li>
            }
            return <li><i className="fa fa-check-circle-o"></i>{key}</li>
        })
    );
}
function PricingPlan({ eventInfo }: any) {


    let ticketTypeshtml: any = [];
    let ticketTypessorted: any = [];
    if (eventInfo != null && eventInfo.tickettypes != null) {
        ticketTypessorted = [].slice.call(Object.keys(eventInfo.tickettypes)).sort((a: any, b: any) => { 
            const ticketA = eventInfo.tickettypes[a];
            const ticketB = eventInfo.tickettypes[b];
            
            // First sort by priority if available
            if (ticketA.priority !== undefined && ticketB.priority !== undefined) {
                return ticketA.priority - ticketB.priority;
            } else if (ticketA.priority !== undefined) {
                return -1; // Tickets with priority come first
            } else if (ticketB.priority !== undefined) {
                return 1; // Tickets with priority come first
            }
            
            // Then sort by price (descending)
            return parseFloat(ticketB.price) - parseFloat(ticketA.price);
        });
        ticketTypessorted.forEach(key => {
            ticketTypeshtml.push(
                <div className="col-lg-4 col-md-6 col-sm-6">
                    <div className="price text-center wow fadeInUp" data-wow-duration="100ms">
                        <h3 className="price-head"><a target="_blank" href={"/event/" + eventInfo.eventcode + "/schedule"}>{key}</a></h3>
                        {(eventInfo.status == 'CLOSED' || eventInfo.tickettypes[key].status == 'CLOSED') && <h2 className="soldout">Sold Out</h2>}

                        {(eventInfo.status != 'CLOSED' && eventInfo.tickettypes[key].status != 'CLOSED') && eventInfo.tickettypes[key].initialprice && <span className="initialPrice"><small>&#8377;</small>{eventInfo.tickettypes[key].initialprice}</span>}
                        {(eventInfo.status != 'CLOSED' && eventInfo.tickettypes[key].status != 'CLOSED') && <h2><small>&#8377;</small>{eventInfo.tickettypes[key].price}</h2>}
                        <ul>
                            {getDetails(eventInfo.tickettypes[key].content)}
                        </ul>
                        {(eventInfo.status != 'CLOSED' && eventInfo.tickettypes[key].status != 'CLOSED') && <a href="#register" title="" data-scroll-nav="8" className="btn-default">REGISTER</a>}
                        {<a target="_blank" href={"/event/" + eventInfo.eventcode + "/schedule"} title="" className="btn-default">More Details</a>}
                    </div> {/* <!--price end--> */}
                </div>
            );
        });
    }



    return (
        <section className="event-price-sec sec-padding" id="price" data-scroll-index="5">
            <div className="container">
                <div className="sec-title">
                    <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-thumbs-up fa-stack-1x"></i></span></span>
                    <h3 className="wow fadeInRight" data-wow-duration="500ms">Entry Passes <small> / Best Value @ Best Price</small></h3>
                </div> {/* <!--sec-title end--> */}
                <div className="price-sec-details">
                    <div className="row">
                        {ticketTypeshtml}
                    </div>
                </div> {/* <!--price-sec-details end--> */}
            </div>
        </section>
    );
}
export { PricingPlan }